export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=63a477cf"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Highway/Index.vue?vue&type=template&id=63a477cf
// module id = 2721
// module chunks = 31